export default __webpack_public_path__ + "static/media/home1.c02fe8cd.png";